/*
 * Copyright (c) 2026.
 * This file is part of the Compo B2B application.
 * (c) Compo soft
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

/**
 * Часть составной (Composite) характеристики — `CompositeFeaturePartDto` бэкенда.
 *
 * Значение составной характеристики собирается из упорядоченного списка частей:
 * каждая часть — либо ссылка на характеристику (`featureId`), либо литеральный
 * текст (`value`). Ровно одно из `featureId` / `value` должно быть заполнено.
 */
export interface CompositeFeaturePart {
  /** id части; есть при чтении, при создании можно не передавать. */
  id?: number;
  /** Ссылка на глобальную характеристику (для части-ссылки), иначе null. */
  featureId?: number | null;
  /** Название характеристики — только для чтения, заполняется бэкендом на GET. */
  featureHeader?: string;
  /** Литеральный текст (для части-литерала), иначе null. */
  value?: string | null;
  /** Позиция части в сборке значения (с 0). */
  sort: number;
}
